import { render, staticRenderFns } from "./GeneralSettingsTab.vue?vue&type=template&id=335d4371&scoped=true"
import script from "./GeneralSettingsTab.vue?vue&type=script&lang=js"
export * from "./GeneralSettingsTab.vue?vue&type=script&lang=js"
import style0 from "./GeneralSettingsTab.vue?vue&type=style&index=0&id=335d4371&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335d4371",
  null
  
)

export default component.exports